import React from 'react';
import Breadcrumb from '../Breadcrumb';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { productManagement } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import { Link } from 'react-router-dom';

const ProductManagement = () => {
  return (
    <div className="page-container-product">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
            <h1 className='heading'>Product Strategy & Management</h1>
          </div>
            <Link to="/product-strategy-and-management" className='no-decoration'><Breadcrumb text={"Product Strategy & Management"} /></Link>  
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={productManagement} />
        <FooterServices />
          <Footer />
    </div>
  )
}

export default ProductManagement